import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@common/components/ui/tooltip"

export function Hint({
  text,
  children,
}: {
  text: string | null
  children: React.ReactElement
}): React.ReactElement {
  if (text === null) return children

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">{children}</span>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  )
}
